// HP filtrace — taby kategorií + kaskádové selecty parametrů
// Data se parsují z HTML stránek kategorií (Shoptet filter sekce) a cachují.

const HP_FILTERS_CACHE_PREFIX = 'hpFilters:';
const HP_FILTERS_CACHE_TTL = 60 * 60 * 1000; // 1 hodina

const hpFiltersMemoryCache = new Map();
let hpFiltersController = null;
let hpFiltersState = null;

$(document).ready(function () {
	if ($(".in-index").length === 0 || $(".my-filters").length === 0) return;

	// Carousel s filtrací se přesouvá z #content na začátek #content-wrapper
	$(".wide-carousel").has(".my-filters").addClass("has-filters").prependTo("#content-wrapper");

	if (typeof shopDataLayer === 'undefined' || !shopDataLayer.homepage || !shopDataLayer.homepage.filters) return;

	const categories = shopDataLayer.homepage.filters.categories;
	if (!categories || categories.length === 0) return;

	initHomepageFilters(categories);
});

function initHomepageFilters(categories) {
	hpFiltersState = {
		categories: categories,
		activeIndex: 0,
		selections: {},
	};

	renderTabs(categories, 0);
	updateSubmit(categories[0].url);
	loadAndRender();

	// Delegované eventy — bindují se jen jednou, přežijí každý re-render
	$(document).on("click", ".my-filters__list > li", function () {
		const index = $(this).index();
		if (index === hpFiltersState.activeIndex) return;

		$(".my-filters__list > li").removeClass("active");
		$(this).addClass("active");

		hpFiltersState.activeIndex = index;
		hpFiltersState.selections = {};
		loadAndRender();
	});

	$(document).on("change", ".my-filtration .my-filter", function () {
		hpFiltersState.selections[$(this).attr("data-filter-id")] = $(this).val();
		loadAndRender();
	});

	$(document).on("click", ".my-filters .reset-filters", function () {
		hpFiltersState.selections = {};
		loadAndRender();
	});
}

function loadAndRender() {
	const category = hpFiltersState.categories[hpFiltersState.activeIndex];
	const url = buildFilterUrl(category.url, hpFiltersState.selections);
	const $wrapper = $(".my-filters");

	$wrapper.addClass("my-filters--loading");
	$wrapper.find(".my-filter").prop("disabled", true);

	loadFilterData(url, category.filters)
		.then(function (data) {
			renderSelects(data, category.filters, hpFiltersState.selections);
			// selections se v renderSelects mohly pročistit — URL složíme znovu
			updateSubmit(buildFilterUrl(category.url, hpFiltersState.selections));
			$wrapper.removeClass("my-filters--loading");
		})
		.catch(function (error) {
			if (error.name === "AbortError") return;
			// Při chybě zůstávají poslední funkční options, tlačítko vede na poslední známou URL
			console.warn("HP filtrace: načtení filtrů selhalo", error);
			$wrapper.find(".my-filter").prop("disabled", false);
			$wrapper.removeClass("my-filters--loading");
		});
}

// ---------- Datová vrstva ----------

function loadFilterData(url, filters) {
	// Nový požadavek vždy ruší rozběhnutý fetch (i při cache hitu, ať starý fetch nepřepíše novější render)
	if (hpFiltersController) {
		hpFiltersController.abort();
		hpFiltersController = null;
	}

	const key = hpFiltersCacheKey(url, filters);
	const cached = hpFiltersCacheGet(key);
	if (cached) return Promise.resolve(cached);

	hpFiltersController = new AbortController();

	return fetch(url, { signal: hpFiltersController.signal })
		.then(function (response) {
			if (!response.ok) throw new Error("HTTP " + response.status);
			return response.text();
		})
		.then(function (html) {
			// DOMParser nestahuje obrázky ani nespouští skripty z parsované stránky
			const doc = new DOMParser().parseFromString(html, "text/html");
			const data = parseFilterDocument(doc, filters);
			hpFiltersCacheSet(key, data);
			return data;
		});
}

function parseFilterDocument(doc, filters) {
	const data = {};

	filters.forEach(function (filter) {
		const key = String(filter.id);
		const sectionSelector = filter.id === 'manufacturer' ? ".filter-section-manufacturer" : ".filter-section-parametric-id-" + filter.id;
		const section = doc.querySelector(sectionSelector);
		if (!section) return;

		const heading = section.querySelector("h4 span") || section.querySelector("h4");
		const options = [];

		section.querySelectorAll("fieldset div > input[data-url]").forEach(function (input) {
			const holder = input.closest("div");
			const label = holder ? holder.querySelector("label") : null;
			options.push({
				value: input.value,
				valueId: hpFiltersParseValueId(input, filter.id),
				disabled: !!(label && label.classList.contains("disabled")),
				checked: input.checked,
			});
		});

		data[key] = {
			label: filter.label || (heading ? heading.textContent.trim() : key),
			options: options,
		};
	});

	return data;
}

function hpFiltersParseValueId(input, filterId) {
	if (filterId === 'manufacturer') {
		// URL značky má tvar /kategorie:znacka/ — vytáhneme slug z cesty
		const match = (input.getAttribute("data-url") || "").match(/:([^/:?]+)\//);
		return match ? match[1] : "";
	}
	// id inputu má tvar "pv[]357" → valueId "357"
	return (input.id || "").replace("pv[]", "");
}

function buildFilterUrl(categoryUrl, selections) {
	let url = categoryUrl;
	const params = [];

	Object.keys(selections).forEach(function (key) {
		if (key === 'manufacturer') {
			// Značka se vkládá do cesty: /kategorie:znacka/
			url = url.replace(/\/$/, ":" + selections[key] + "/");
		} else {
			params.push("pv" + key + "=" + selections[key]);
		}
	});

	return params.length > 0 ? url + "?" + params.join("&") : url;
}

// ---------- Cache ----------

function hpFiltersCacheKey(url, filters) {
	const ids = filters.map(function (filter) {
		return filter.id;
	});
	return HP_FILTERS_CACHE_PREFIX + url + "|" + ids.join(",");
}

function hpFiltersCacheGet(key) {
	if (hpFiltersMemoryCache.has(key)) return hpFiltersMemoryCache.get(key);
	try {
		const raw = sessionStorage.getItem(key);
		if (!raw) return null;
		const entry = JSON.parse(raw);
		if (Date.now() - entry.time > HP_FILTERS_CACHE_TTL) {
			sessionStorage.removeItem(key);
			return null;
		}
		hpFiltersMemoryCache.set(key, entry.data);
		return entry.data;
	} catch (e) {
		return null;
	}
}

function hpFiltersCacheSet(key, data) {
	hpFiltersMemoryCache.set(key, data);
	try {
		sessionStorage.setItem(key, JSON.stringify({ time: Date.now(), data: data }));
	} catch (e) {
		// sessionStorage nedostupná nebo plná — stačí paměťová cache
	}
}

// ---------- Render ----------

function renderTabs(categories, activeIndex) {
	const $list = $(".my-filters__list").empty();

	categories.forEach(function (category, index) {
		$("<li data-url='" + category.url + "'" + (index === activeIndex ? " class='active'" : "") + "><span>" + category.label + "</span></li>").appendTo($list);
	});
}

function renderSelects(data, filters, selections) {
	const $filtration = $(".my-filtration").empty();

	filters.forEach(function (filter) {
		const key = String(filter.id);
		const filterData = data[key];
		if (!filterData) {
			console.warn("HP filtrace: filtr '" + key + "' na stránce kategorie neexistuje — select se nevykreslí");
			return;
		}

		// Zvolená hodnota už v zúžených datech nemusí existovat → výběr se pročistí na placeholder
		const selectionExists = filterData.options.some(function (option) {
			return option.valueId === selections[key];
		});
		if (selections[key] && !selectionExists) {
			delete selections[key];
		}
		const selectedId = selections[key];

		const $select = $("<select class='my-filter' data-filter-id='" + key + "'></select>");
		$("<option class='default' value='' disabled" + (selectedId ? "" : " selected") + ">" + filterData.label + "</option>").appendTo($select);

		filterData.options.forEach(function (option) {
			$("<option value='" + option.valueId + "'" + (option.valueId === selectedId ? " selected" : "") + (option.disabled ? " disabled" : "") + ">" + option.value + "</option>").appendTo($select);
		});

		$select.appendTo($filtration);
	});
}

function updateSubmit(url) {
	$(".my-filters .submit-filters").attr("href", url);
}
